import styled from '@emotion/styled'
import palette from 'theme/color/defaults'

export const FlyoutOuter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  overflow: hidden;
`

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  background: #ffffff;
  overflow: hidden;
  padding: 20px 20px 0;
`

export const DrawerHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 0 8px;
  border-bottom: 1px solid rgba(227, 229, 232, 1);
  flex-shrink: 0;
`

export const DrawerTitle = styled.h2`
  margin: 0;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: rgba(7, 7, 15, 0.87);
  line-height: 24px;
`

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0 20px;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
`

// SaveButton is intentionally not used in VehicleSnapshotsFlyout.jsx.
// Enzyme 3 finds 2 nodes for attribute selectors on styled components (e.g. [data-testid]),
// causing .simulate() / .prop() failures. A plain <button> with inline style is used instead.
export const SaveButton = styled.button`
  display: flex;
  height: 30px;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 3px;
  border: 1px solid #0b2e6b;
  background: ${({ disabled }) => (disabled ? '#f1f2f3' : '#fff')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? 'rgba(7, 7, 15, 0.4)' : '#0b2e6b')};

  &:hover:not(:disabled) {
    background: #f0f4ff;
  }
`

export const SkeletonCard = styled.div`
  height: 72px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`

export const ErrorBanner = styled.div`
  padding: 10px 12px;
  border-radius: 3px;
  background: rgba(193, 39, 45, 0.08);
  border: 1px solid rgba(193, 39, 45, 0.3);
  font-family: Arial, sans-serif;
  font-size: 13px;
  color: rgba(193, 39, 45, 1);
  line-height: 18px;
`

export const SectionHeader = styled.div`
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
  color: rgba(7, 7, 15, 0.7);
`

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CapacityIndicator = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const CapacityLine = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: ${({ atLimit }) =>
    atLimit ? 'rgba(193, 104, 14, 1)' : 'rgba(7, 7, 15, 0.5)'};
`

export const OtherSectionEmptyText = styled.div`
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: rgba(7, 7, 15, 0.4);
  line-height: 16px;
  padding: 4px 0;
`

export const NoSnapshotsCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e3e5e8;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(7, 7, 15, 0.1);
  box-sizing: border-box;
`

export const NoSnapshotsCardText = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  color: ${palette.blackSecondary};
  line-height: 16px;
`
